import { useMemo } from "react";

// Gentle drifting native seeds across the screen
export default function SeedField({ count = 18 }) {
  const seeds = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => {
        const size = 4 + Math.random() * 8;
        return {
          id: i,
          left: `${Math.random() * 100}%`,
          size,
          duration: `${16 + Math.random() * 20}s`,
          delay: `${Math.random() * -30}s`,
          opacity: 0.25 + Math.random() * 0.5,
        };
      }),
    [count]
  );

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" data-testid="seed-field">
      {seeds.map((s) => (
        <span
          key={s.id}
          className="seed-particle"
          style={{
            left: s.left,
            width: `${s.size}px`,
            height: `${s.size * 1.6}px`,
            animationDuration: s.duration,
            animationDelay: s.delay,
            opacity: s.opacity,
          }}
        />
      ))}
    </div>
  );
}
